module.exports = __webpack_public_path__ + "static/media/Plain-Thin.da5cb46a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Plain-Thin.woff
// module id = 976
// module chunks = 0 1 2 3 4 5 6 9